import React from "react";
import { Policies } from "../modules/Policies";

export function PoliciesListPage(props) {
  return <Policies {...props} />;
}
